import style from "./index.module.css";

export const PlusIcon = () => <div className={style.plus}></div>;
